import { useQuery } from '@tanstack/react-query'

import { ExperimentsService } from '@mc/api'

// queries the /jsonapi/v1/experiments/sessionless endpoint
// and returns bucket
export const useExperiment = (flagName: string) => {
  const experiment = useExperiments()

  return {
    ...experiment,
    data: experiment.data?.find((exp) => exp.name === flagName)?.value ?? null,
  }
}

export const useExperiments = () =>
  useQuery(['experiments'], () => ExperimentsService.getExperiments(), {
    staleTime: Infinity,
  })
